import * as klaro from 'klaro/dist/klaro-no-css';
import './cookie-policy.html.twig';
import './cookie-policy.scss';

export default function () {
  const config = {
    elementID: 'cookie-policy',
    htmlTexts: true,
    hideLearnMore: false,
    acceptAll: true,
    default: true,
    translations: {
      en: {
        ok: 'Yes, I agree',
        decline: 'No, I decline',
        consentNotice: {
          description: `<h3 id="id-cookie-title">Cookies</h3><p>We use cookies to ensure that we give you the best experience on our website. If you continue to use this site you are giving your consent for us to set cookies.</p>`,
          learnMore: 'Find out more',
        },
        consentModal: {
          title: `Services we would like to use`,
          description: `<p>This website uses third-party applications. To protect and manage your privacy you can review and control these apps here. To learn more, please read our <a href="/fine-print#cookie+policy">cookie policy</a>.</p>`,
        },
        googleAnalytics: {
          title: 'Google Analytics',
          description: 'The analytics service ran by a most definitely non-evil company.',
        },
        purposes: {
          statistics: {
            title: 'Statistics',
            description: 'The technical storage or access that is used exclusively for statistical purposes.',
          },
          marketing: {
            title: 'Marketing',
            description:
              'The technical storage or access required to create user profiles to send advertising, or to track the user on a website or across several websites for similar marketing purposes.',
          },
          functional: {
            title: 'Functional ',
            description: 'The technical storage or access required for correct functioning of the site.',
          },
        },
      },
    },
    services: [
      /** Note, the order of items in this list is important. Its important that any list items that talk to GTM do so in a consistent order. */
      {
        name: 'klaro',
        title: 'Klaro',
        description: 'Manages cookie consent preferences',
        purposes: ['functional'],
        cookies: [/klaro/],
        required: true,
      },
      {
        /* Note that GTM controls tags for GA, Hotjar and LinkedIn */
        /** The GTM script is only loaded after this service is accepted. */
        name: 'google-tag-manager',
        title: 'Google tag manager',
        description: 'Controls enabling/disabling other services',
        purposes: ['statistics', 'marketing'],
        onInit: `
          window.dataLayer = window.dataLayer || [];
          window.gtag = function() { dataLayer.push(arguments)}
          gtag('consent',
           'default',
            {
             'ad_storage': 'denied',
             'ad_user_data': 'denied',
             'ad_personalization': 'denied',
             'analytics_storage': 'denied',
             'personalization_storage': 'denied',
             'security_storage': 'denied',
             'functionality_storage': 'granted',
            })
        `,
      },
      {
        name: 'google-analytics',
        title: 'Google Analytics',
        description: 'These services process personal information to optimize the service that this website offers.',
        purposes: ['statistics'],
        cookies: [/^_ga(_.*)?/, /^_gid/],
        onAccept: `
          gtag('consent', 'update', {
            'analytics_storage': 'granted'
          })
          dataLayer.push({'event': 'klaro-google-analytics-accepted'})

        `,
        onDecline: `
          gtag('consent', 'update', {
            'analytics_storage': 'denied'
          })
          dataLayer.push({'event': 'klaro-google-analytics-declined'})
        `,
      },
      {
        name: 'google-ads',
        purposes: ['marketing'],
        cookies: [],
        /** Any GA4 tags that were previously denied should refire when this is accepted. */
        onAccept: `
          gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted'
          })
        `,
        onDecline: `
          gtag('consent', 'update', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied'
          })
        `,
      },
      {
        name: 'hotjar',
        title: 'Hotjar',
        description:
          'An analytics service that processes personal information to optimize the service this website offers.',
        purposes: ['statistics', 'marketing'],
        cookies: [/^_hj(.*)?/],
        onAccept: `
          gtag('consent', 'update', {
            'analytics_storage': 'granted',
            'ad_storage': 'granted',
          })
          dataLayer.push({'event': 'klaro-hotjar-accepted'})
        `,
        onDecline: `
          gtag('consent', 'update', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied',
          })
          dataLayer.push({'event': 'klaro-hotjar-declined'})
        `,
      },
      {
        name: 'linkedin',
        title: 'Linkedin',
        description: 'Linkedin tracking cookies.',
        purposes: ['marketing'],
        cookies: [/^li_(.*)?/],
        onAccept: `
          gtag('consent', 'update', {
            'personalization_storage': 'granted',
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
          })
          dataLayer.push({'event': 'klaro-linkedin-accepted'})
        `,
        onDecline: `
          gtag('consent', 'update', {
            'personalization_storage': 'denied',
            'ad_storage': 'denied',
            'analytics_storage': 'denied',
          })
          dataLayer.push({'event': 'klaro-linkedin-declined'})
        `,
      },
    ],
  };

  window.klaro = klaro;
  window.klaroConfig = config;
  klaro.setup(config);

  const el = document.querySelector('.cookie-notice');

  if (!el) {
    return;
  }

  const successButton = document.querySelector('.cm-btn.cm-btn-success');
  const declineButton = document.querySelector('.cm-btn.cm-btn-danger.cn-decline');
  const infoButton = document.querySelector('.cm-link.cn-learn-more');
  successButton.ariaLabel = 'Yes, I agree to cookie policy';
  declineButton.ariaLabel = 'No, I decline cookie policy';
  infoButton.ariaLabel = 'I would like more information about cookie policy';
}

